<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import Home from './pages/home'
import { postAction, getAction } from '@/api/manage.js'
import Home from './pages/home/login'
export default {
  components: {Home},
  name: 'App',
  data() {
    if (
      !this.$ls.get('token') ||
      this.$ls.get('token') == 'null' ||
      this.$ls.get('token') == 'undefined'
    ) {
      this.$ls.set('token', this.getUrlVars()['token'])
    }
    return {

    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(val)
        this.name = val.name
      },
      deep: true
    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<style lang="less">
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: Satoshi-Regular !important;
}
p,div,span{
  word-break: break-word;
}
.page_title{
  font-size: 14px;
  font-family: Graphik;
  font-weight: 600;
  color: #262B2F;
  margin: 30px;
  display: flex;
  justify-content: space-between;
}
.flex_all {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/App.vue